import React, { useCallback, useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Button, { buttonType } from '../../Button';
import { useLabels } from '../../../hooks';
import { UserContext, UserType, PageContext } from '../../../contexts';
import styles from '../SignUp/SignUp.module.scss';

const TempAlert = ({ onClose, onButtonClick }) => {

  const { getLabel, getLocalUrlByLanguage } = useLabels();
  const { userType, orgData } = useContext(UserContext);
  const { pageKey } = useContext(PageContext);
  const navigate = useNavigate();

  const view = useMemo(() => {
        let view = 'signup';
        if (userType !== UserType.guest || (pageKey === "login" && orgData)) {
          view = 'subscription';
        }
        return view;
      }, [orgData, pageKey, userType]);

  const onSignUpButtonClickHandle = useCallback(() => {
    navigate(getLocalUrlByLanguage(`/contact_us`));
    onClose();
  }, [onClose, navigate, getLocalUrlByLanguage]);

  const title = useMemo(() => {
    return <div className={styles.title} dangerouslySetInnerHTML={{ __html: getLabel('alert_temp_block_title') }} />;
  }, [getLabel, view]);

  const content = useMemo(() => {
    return <div className={styles.content} dangerouslySetInnerHTML={{ __html: getLabel('alert_temp_block_content') }} />;
  }, [getLabel, view]);

  const signUpButton = useMemo(() => {
    return <Button type={buttonType.premium} className={styles.sign_up_button} onClick={onSignUpButtonClickHandle} >{getLabel('alert_temp_block_button')}</Button>;
  }, [getLabel, onSignUpButtonClickHandle, view]);


  return <div className={styles.container}>
    {title}
    {content}
    <div className={styles.buttons}>
      {signUpButton}
    </div>
  </div>;
};

export default TempAlert;